import PropTypes from 'prop-types';
import React from 'react';

import { SENDER_TYPES } from '../../utils/senderTypes';
import ChatMessageList from './ChatMessageList';
import ChatTypingIndicator from './ChatTypingIndicator';

export const INITIAL_LOADING_LABEL = 'Loading';
export const INITIAL_LOADING_MESSAGE = 'Loading your application...';

/**
 * Scrollable message region shared by the connected (Direct Line) and
 * fallback render paths: the message list, the typing or initial-loading
 * indicator, and the scroll anchor.
 * @component
 */
export default function ChatMessageRegion({
  activeMessageIndex,
  errorMessage,
  isInitialLoading = false,
  isTyping,
  messageEndRef,
  messageRegionRef,
  messages,
  onActiveMessageIndexChange,
  onExitMessageNavigation,
  onOptionSelect,
  onStartNewChat,
  showAiDisclaimer,
}) {
  return (
    <div className="va-chatbot-message-region" ref={messageRegionRef}>
      <ChatMessageList
        activeMessageIndex={activeMessageIndex}
        errorMessage={errorMessage}
        messages={messages}
        onActiveMessageIndexChange={onActiveMessageIndexChange}
        onExitMessageNavigation={onExitMessageNavigation}
        onOptionSelect={onOptionSelect}
        onStartNewChat={onStartNewChat}
        showAiDisclaimer={showAiDisclaimer}
      />
      {isInitialLoading ? (
        <va-loading-indicator
          data-testid="chat-initial-loading-indicator"
          label={INITIAL_LOADING_LABEL}
          message={INITIAL_LOADING_MESSAGE}
        />
      ) : (
        <ChatTypingIndicator isTyping={isTyping} />
      )}
      <div
        aria-hidden="true"
        className="va-chatbot-message-end-anchor"
        data-testid="chat-message-end-anchor"
        ref={messageEndRef}
      />
    </div>
  );
}

ChatMessageRegion.propTypes = {
  isTyping: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      sender: PropTypes.oneOf([SENDER_TYPES.USER, SENDER_TYPES.BOT]).isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  showAiDisclaimer: PropTypes.bool.isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  activeMessageIndex: PropTypes.number,
  errorMessage: PropTypes.string,
  isInitialLoading: PropTypes.bool,
  messageEndRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  messageRegionRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  onActiveMessageIndexChange: PropTypes.func,
  onExitMessageNavigation: PropTypes.func,
  onStartNewChat: PropTypes.func,
};
